/**
 * Geld-Helfer — Beträge IMMER als Integer in Cent (ADR-012, 07 – Datenmodell).
 * Keine Floats: Formatierung erst in der UI. Negative Beträge sind erlaubt
 * (Taschengeld darf ins Minus gehen, UI markiert Minus rot — Risiko #9).
 */
/** Addiert Cent-Beträge und garantiert ein Integer-Ergebnis. */
export function addCents(a, b) {
    return Math.trunc(a) + Math.trunc(b);
}
/** Summiert eine Liste von Cent-Beträgen (z. B. Kontostand aus Transaktionen). */
export function sumCents(values) {
    return values.reduce((total, v) => total + Math.trunc(v), 0);
}
/**
 * Parst eine Euro-Eingabe in Cent — tolerant gegenüber üblichen Schreibweisen:
 * "2", "2,50", "2.50", "2,", "2.", "2,-", "2 €", ",5" (→ 0,50). Wirft bei echt
 * ungültiger Eingabe (leer, Buchstaben, > 2 Nachkommastellen).
 */
export function parseEuroToCents(input) {
    let s = input.trim().replace(/[€\s]/g, '').replace(',', '.');
    // Deutsche "glatt"-Notation: "2,-" bzw. "2." → 2,00
    s = s.replace(/\.-?$/, '');
    // Führendes Komma/Punkt: ",5" → "0.5"
    if (s.startsWith('.'))
        s = '0' + s;
    else if (s.startsWith('-.'))
        s = '-0' + s.slice(1);
    if (!/^-?\d+(\.\d{1,2})?$/.test(s)) {
        throw new Error(`Ungültiger Geldbetrag: "${input}"`);
    }
    const negative = s.startsWith('-');
    const abs = negative ? s.slice(1) : s;
    const [euros, cents = ''] = abs.split('.');
    const centStr = cents.padEnd(2, '0');
    const value = Number(euros) * 100 + Number(centStr);
    return negative ? -value : value;
}
/** Formatiert Cent als deutschen Euro-String, z. B. 1234 → "12,34 €", -500 → "-5,00 €". */
export function formatCents(cents, currency = '€') {
    const negative = cents < 0;
    const abs = Math.abs(Math.trunc(cents));
    const euros = Math.floor(abs / 100);
    const rest = (abs % 100).toString().padStart(2, '0');
    return `${negative ? '-' : ''}${euros},${rest} ${currency}`;
}
//# sourceMappingURL=money.js.map